import { schema } from 'normalizr';

export const user = new schema.Entity('users');
export const accessToken = new schema.Entity('access_tokens');
export const productSystem = new schema.Entity('product_systems');
export const projectOfferPosition = new schema.Entity('project_offer_positions');
export const projectConsumption = new schema.Entity('project_consumptions');
export const documentationFile = new schema.Entity('documentation_files');

export const documentationFileUserInfo = new schema.Entity('documentation_file_user_infos');

export const productSystemItem = new schema.Entity('product_system_items', {
  product_system: productSystem
});

export const projectOfferPositions = new schema.Entity('project_offer_positions', {
  project: project
});

export const projectConsumptions = new schema.Entity('project_consumptions', {
  project: project
});

export const productSolution = new schema.Entity('product_solutions', {
  product_system: productSystem,
  product_system_items: [productSystemItem]
});
export const projectunit = new schema.Entity('projectunits', {
  product_solutions: [productSolution],
});

export const project = new schema.Entity('projects', {
  projectunits: [projectunit],
  project_offer_positions: [projectOfferPosition],
  project_consumptions: [projectConsumption]
});

export const arrayOfUsers = [user];
export const arrayOfAccessTokens = [accessToken];
export const arrayOfProjects = [project];

export const arrayOfProductSystems = [productSystem];

export const arrayOfProductSystemItems = [productSystemItem];

export const arrayOfProductSolutions = [productSolution];

export const arrayOfDocumentationFiles = [documentationFile];

export const arrayOfDocumentationFileUserInfos = [documentationFileUserInfo];



// WEBPACK FOOTER //
// ./src/store/schema.js